var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"soltFooter",class:{ ios: _vm.isIOS, ipx: _vm.isIPX, ipmx: _vm.isIPMX },style:({ backgroundColor: _vm.bgcolor })},[_c('div',{staticClass:"soltFooter--view l-flex l-flex__c"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }